import React from "react";
import { FaCrosshairs, FaSearch } from "react-icons/fa";
import { getTargetKey } from "../../utils/pageTarget";

const PageTargetSelector = ({
  pageTarget,
  title = "Page Target",
  subtitle = "Choose whether you're editing Homepage or a specific Genre page.",
}) => {
  return (
    <div className="mb-4 rounded-4 border bg-white p-3 shadow-sm">
      <div className="d-flex flex-column gap-2">
        <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
          <div>
            <div className="d-flex align-items-center gap-2 fw-semibold text-dark">
              <FaCrosshairs />
              <span>{title}</span>
            </div>
            <div className="text-muted small">{subtitle}</div>
          </div>
          <div className="badge bg-primary-subtle text-primary-emphasis px-3 py-2">
            Editing: {pageTarget.selectedTargetLabel}
          </div>
        </div>

        <div className="row g-3">
          <div className="col-lg-5">
            <div className="input-group">
              <span className="input-group-text">
                <FaSearch />
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search homepage or genre..."
                value={pageTarget.targetSearch}
                onChange={(event) => pageTarget.setTargetSearch(event.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-7">
            <select
              className="form-select"
              value={pageTarget.selectedTargetKey}
              onChange={(event) => pageTarget.setSelectedTargetKey(event.target.value)}
              disabled={pageTarget.isLoadingTargets}
            >
              {pageTarget.filteredTargets.map((target) => (
                <option key={getTargetKey(target)} value={getTargetKey(target)}>
                  {target.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {pageTarget.targetError ? (
          <div className="text-danger small">{pageTarget.targetError}</div>
        ) : null}
      </div>
    </div>
  );
};

export default PageTargetSelector;
